import React from "react"
import Portal from "./Portal"

export default class Occulus extends React.Component {
  
  render(){
    const timestamp = () => { 
      const hour = () => { //convert 24-hour clock to 12-hour clock with AM/PM distinction 
        const stampHour = this.props.date.hour;
        if (stampHour === 0){
          return 12;
        } if (stampHour > 12){
          return stampHour - 12;
        } else {
          return stampHour;
        }
      } 
      const minute = this.props.date.minutes < 10 ? `0${this.props.date.minutes}`: this.props.date.minutes;
      return (
        `${hour()}:${minute}`
      )
    }

    const description = () => { //convert lowercase description to uppercase text
      if (this.props.current.subdescription != null){
        const textDescrip = this.props.current.subdescription;
        return textDescrip.replace(/(^\w{1})|(\s+\w{1})/g, i=>i.toUpperCase());
        //lookbehind does not work in Safari**
        //return textDescrip.replace(/(^\w)|(?<=\s)\w/g, i=>i.toUpperCase());
      }
    }
    
    return (
      <div className="occulus">
          <h2 className="portal-des" id="occulus-top">
            {this.props.current.description}
            <br/>
          </h2>
          <h3 id="occulus-top" style={{color: "var(--blue)"}}>
            {description()}
          </h3>
    
          <Portal current={this.props.current}/>
          
          <div className="portal-des" id="occulus-bottom">
            <h2>{timestamp()}</h2><h2 id="meridiem">{this.props.date.hour >= 12 ? "PM": "AM"}</h2>
          </div>
      </div>
    );
  }
}
